import { store } from "..";
import { NotificationActions } from "./actions";

export function successNotificationFromPromise(title: string) {
  return function <T>(x: T) {
    store.dispatch(
      NotificationActions.setNotification({ variant: "success", title })
    );
    return Promise.resolve(x);
  };
}
